<template>
  <div class="ZoomSvgComponent">

        <div id="zoom_place" class="image-svg-zoom"></div>
        <div v-if="pinsShow" class="pinsOpt">
          <input class="checkboxPinOptionZoom" type="checkbox" value=""> {{lang.label_pinSwitch}}
        </div>
        <div id="barimage" class="bar-image"></div>
  </div>
</template>

<script>

import LibraryTypes from '@/constants/LibraryTypes'
export default {
  name: "ZoomSvgComponent",
  components: {



  },
  props:{
    lang: Object,
    svgObject: Object
  },
  data () {
    return {
      currentPackage: 0,
    }
  },
  computed: {
    id(){
        return "id_" + this.svgObject.revisionId;
    },
    variant(){
        if (this.$store.getters.s_skinVariant == "dark"){
            return "light";
        }else{
            return "dark";
        }
    
    },
    pinsShow() {
      return this.svgObject.type == LibraryTypes.PART || this.svgObject.type == LibraryTypes.SYMBOL;
    }
  },
  created() {
    this.displaySvg();
    

  },
  updated(){
    //this.displaySvg();
  },
  watch: {
    
    currentPackage: function(newVal, oldVal){

            

            let barValue = document.getElementById("barValueZoom");
            if (barValue != null){
              let index = this.currentPackage + 1;
              barValue.value = this.packages[this.currentPackage] + " (" + index + "/" + this.packages.length +")";

              let leftbar = document.getElementById("leftbar_" + this.id);
              let rightbar = document.getElementById("rightbar_" + this.id);

              if (this.currentPackage == 0){
                leftbar.disabled = true;
              }else{
                leftbar.disabled = false;
              }
              
              if (this.currentPackage == this.packages.length - 1){
                rightbar.disabled = true;
              }else{
                rightbar.disabled = false;
              }

                          
              
              for (var i = 0, le = this.packages.length; i < le; i++) {
                  var layer = "PACKAGES_"+this.packages[i];

                  if (i == this.currentPackage) {
                      if (this.place.getElementsByClassName(layer)[0] != undefined) {
                          this.place.getElementsByClassName(layer)[0].style["visibility"] = "visible";
                      }
                      

                  } else {
                      if (this.place.getElementsByClassName(layer)[0] != undefined) {
                          this.place.getElementsByClassName(layer)[0].style["visibility"] = "hidden";
                      }
                  }


              }
            }
    }
  },
  methods: {
      async loadSVG(blob, id){

        let svgData = await new Response(blob).text();
        
        let place = document.getElementById("zoom_place");
        place.innerHTML = "";

        var parser = new DOMParser();
        var doc = parser.parseFromString(svgData, "image/svg+xml");
        doc.documentElement.setAttribute("width", 650);
        doc.documentElement.setAttribute("height", 650);
                
        place.appendChild(doc.documentElement);
        
        
      let pos1 = id.indexOf(LibraryTypes.PART);
      let pos2 = id.indexOf(LibraryTypes.SYMBOL);
        
        if (pos1 > -1 || pos2 > -1){
            
            this.buildSymbolViewer(doc, place);
        }
        this.pinsToggle();
      },
      displaySvg(){

        let vue = this;
        const obj = {
            type: this.svgObject.type,
            name: this.svgObject.name,
            id: this.svgObject.id,
            revisionId: this.svgObject.revisionId
        }

        let action = this.$store.getters.sectionPrefix;
        if (this.svgObject.source == "pm") {
          action = "pm";
        }
        if (this.svgObject.source == "lm") {
          action = "lm";
        }
        if (this.$store.getters.sectionPrefix == "projm") {
          action = "pm";
        }
     
    
        this.$store.dispatch(action + "_getSvg", obj)
        .then((result) => {
            //console.log(result)
            if (result != null){
            
            
                let id = result.id;                          
                vue.loadSVG(result, id);
            
              
            }
        
        })
        
      },
      buildSymbolViewer(doc, place){

        let vue = this;
        
        let svg  = doc.firstChild

        this.place = place;

        
        let symbolbar = document.getElementById("barimage");
        symbolbar.innerHTML = "";
        
        let group = place.getElementsByTagName(`g`);
        
        this.packages = [];
        this.currentPackage = 0;
        for (let i = 0, lei = group.length; i < lei; i++){
            
            let temp = group[i].className.baseVal.split("_");
            if (temp[0] == "PACKAGES"){
            this.packages.push(temp[1])
            }
        }
    

        if(this.packages.length > 1){
            
            this.symbolSvg = svg;

            
            
            
            
            let index = this.currentPackage + 1;
            let valueBar = this.packages[this.currentPackage] + " (" + index + "/" + this.packages.length +")";

            const bar = `<div role="group" class="input-group  input-group-sm">
                        <div class="input-group-prepend">
                        <button disabled="disabled" id="leftbar_`+this.id+`" type="button" class="btn btn-sm btn-`+this.variant+`">&lt;</button>
                        </div> 
                        <input type="text" disabled="disabled" class="form-control form-control-sm" id="barValueZoom" value="`+ valueBar +`" style="text-align:center;"> 
                        <div class="input-group-append">
                        <button id="rightbar_`+this.id+`" type="button" class="btn btn-sm btn-`+this.variant+`">&gt;</button>
                        </div>
                        </div>`;

            symbolbar.innerHTML = bar;

            let leftbar = document.getElementById("leftbar_" + this.id);
            
            leftbar.addEventListener("click", function(e) {
            
            if (vue.currentPackage == 0){
                
            }else{
                
                vue.currentPackage--;
            }
            
            })
            let rightbar = document.getElementById("rightbar_" + this.id);
            rightbar.addEventListener("click", function(e) {
            
            if (vue.currentPackage == vue.packages.length){
                
            }else{
                
                vue.currentPackage++;
            }
            })

            


        }else{
            this.symbolSvg = {};
        }

        // if (this.$store.getters.sectionPrefix == "pm"){
        //   console.log("symbol_select_" + vue.id)
        //     let symbol_select = document.getElementById("symbol_select_" + vue.id);
        //     symbol_select.addEventListener("change", function(e){
        //     console.log(this.value)
        //     let id = "symbol__" + vue.revisionId;

        //     vue.currentSymbolName = this.value;

        //     const obj = {
        //         type: "symbol",
        //         name: this.value,
        //         id: id,
        //         revisionId: vue.revisionId
        //     }
            
            
        //         vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getSvg", obj)
        //         .then((result) => {
                
        //         if (result != null){
                    
        //             let id = result.id;
                                            
        //             vue.loadSVG(result, id);
                    
                    
        //         }
                
        //         })
            

        //     })
        // }
        

        // const obj = {
        //     currentSymbolName: this.currentSymbolName,
        //     currentPackage: this.packages[this.currentPackage],
            
        // }
        
        // this.$store.dispatch("setCurrentSymbol", obj);

    },
    pinsToggle() {

      let vue = this;
      let checkboxPinOptions = document.getElementsByClassName('checkboxPinOptionZoom');


      for (var i = 0; i < checkboxPinOptions.length; i++) {
        checkboxPinOptions[i].addEventListener('click', function () {

          let svg = document.getElementById("zoom_place");

          const pinsNameslayers = svg.querySelectorAll('[class="PINS_NAMES"]')

          const pinsNumberlayers = svg.querySelectorAll('[class="PINS_NUMBERS"]')

          if (this.checked == true) {
            for (let i = 0, lei = pinsNumberlayers.length; i < lei; i++) {
              pinsNumberlayers[i].style.display = "none";
            }
            for (let i = 0, lei = pinsNameslayers.length; i < lei; i++) {
              pinsNameslayers[i].style.display = "block";
            }


          } else {
            for (let i = 0, lei = pinsNumberlayers.length; i < lei; i++) {
              pinsNumberlayers[i].style.display = "block";
            }
            for (let i = 0, lei = pinsNameslayers.length; i < lei; i++) {
              pinsNameslayers[i].style.display = "none";
            }


          }


        })
      }
    },
  }
}
</script>
<style lang="scss">
  .ZoomSvgComponent{
    .image-svg-zoom{
      background-color: #ffffff;
      border: 1px solid #dee2e6;
      border-radius: 0.25rem;
      
      overflow: hidden;
      width: 650px;
      height: 650px;
      margin-left: auto;
      margin-right: auto;
    }
    .bar-image{
      margin-top: 5px;
      margin-bottom: 5px;
      width: 650px;
      margin-left: auto;
      margin-right: auto;
    }
    .pinsOpt{
      margin-top: 5px;
      margin-bottom: 5px;
      width: 650px;
      margin-left: auto;
      margin-right: auto;
    }
  }



</style>



// WEBPACK FOOTER //
// src/components/shared/ZoomSvgComponent.vue